/**
 * Nama peran lama -> peran resmi. Sama dengan LEGACY_ROLE_ALIASES di
 * lumivix-api/src/common/roles.ts dan prisma/migrate-role-names.ts.
 *
 * Server sudah menormalkan peran pada login dan tiap permintaan, tetapi data yang
 * sudah tersimpan di peramban (sesi yang dibuka sebelum pembaruan) dan baris
 * pengguna lama di daftar admin masih bisa memuat 'DOKTER' dsb. Tanpa pemetaan ini
 * dokter pengirim lama tidak dikenali layar sebagai dokter pengirim (filter "pasien
 * saya" tidak diterapkan) sampai ia login ulang.
 */
const LEGACY_ROLE_ALIASES: Record<string, string> = {
  DOKTER: 'REFERRING_DOCTOR',
  DOKTER_PENGIRIM: 'REFERRING_DOCTOR',
  DOKTER_RADIOLOGI: 'RADIOLOGIST',
  RADIOLOGI: 'RADIOGRAPHER',
};

const CANONICAL_ROLES = ['ADMIN', 'RADIOLOGIST', 'RADIOGRAPHER', 'REFERRING_DOCTOR'];

/** Peran resmi untuk nilai yang tersimpan; nilai yang tidak dikenal dikembalikan apa adanya (huruf besar). */
export const normalizeRole = (value?: string | null): string => {
  const key = String(value ?? '')
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');
  if (CANONICAL_ROLES.includes(key)) {
    return key;
  }
  return LEGACY_ROLE_ALIASES[key] ?? key;
};
